import { useUnit } from 'effector-react';
import clsx from 'clsx';
import { $profileFeatureStore } from '@lib/store';
import { UserType } from '@shared/api/rest/users';
import { Icon, Text } from '@shared/widgets';
import AccountIcon from '@assets/icons/account.svg';
import CardIcon from '@assets/icons/card.svg';

interface IShortInfoProps {
  type: UserType;
  locked: boolean;
  cards: number;
  accounts: number;
}

export const ShortInfo = (props: IShortInfoProps) => {
  const profileFeatureStore = useUnit($profileFeatureStore.store);

  if (props.type === UserType.ADMIN || !profileFeatureStore.data?.userManagement.managerAccountsOrCardsPermissions) return null;
  return (
    <div className={clsx(props.locked && 'opacity-50 select-none pointer-events-none')}>
      <div className='pt-8 px-6 pb-6 border-t border-t-gray-black'>
        <div className='flex -mx-2'>
          {props.type === UserType.MANAGER && (
            <div className='flex items-center px-2'>
              <div className='w-8 h-8 mr-3 bg-ice dark:bg-eerie-black flex-none flex items-center justify-center'>
                <Icon icon={<AccountIcon />} color='secondary-inverse' />
              </div>
              <Text>{props.accounts} Accounts</Text>
            </div>
          )}
          {props.type === UserType.USER && (
            <div className='flex items-center px-2'>
              <div className='w-8 h-8 mr-3 bg-ice dark:bg-eerie-black flex-none flex items-center justify-center'>
                <Icon icon={<CardIcon />} color='secondary-inverse' />
              </div>
              <Text>{props.cards} Cards</Text>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
